import { render } from "./BatchControlWidget.vue?vue&type=template&id=01018f35&scoped=true"
import script from "./BatchControlWidget.vue?vue&type=script&lang=js"
export * from "./BatchControlWidget.vue?vue&type=script&lang=js"

import "./BatchControlWidget.vue?vue&type=style&index=0&id=01018f35&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01018f35"]])

export default __exports__